<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
  canToggle: {
    type: Boolean,
    default: false,
  },
  togglingCampaignId: {
    type: [String, Number, null],
    default: null,
  },
});

const emit = defineEmits([
  'edit',
  'delete',
  'viewLogs',
  'toggleEnabled',
  'duplicate',
  'dispatchRemaining',
]);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleViewLogs = campaign => emit('viewLogs', campaign);
const handleToggleEnabled = campaign => emit('toggleEnabled', campaign);
const handleDuplicate = campaign => emit('duplicate', campaign);
const handleDispatchRemaining = campaign =>
  emit('dispatchRemaining', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :has-active-dispatches="campaign.has_active_dispatches"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :is-live-chat-type="isLiveChatType"
      :can-toggle="canToggle"
      :is-toggling="togglingCampaignId === campaign.id"
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
      @view-logs="handleViewLogs(campaign)"
      @toggle-enabled="handleToggleEnabled(campaign)"
      @duplicate="handleDuplicate(campaign)"
      @dispatch-remaining="handleDispatchRemaining(campaign)"
    />
  </div>
</template>
